import React, { useLayoutEffect, useRef } from "react";
import * as THREE from "three";
import { useFrame } from "@react-three/fiber";
import { Cylinder, Edges } from "@react-three/drei";
import { useSmoothPresenceGroup } from "../hooks/useSmoothPresenceGroup";

export default function Cursor({ rotation, position, color, mouse }) {
  const groupRef = useRef();
  const cylRef = useRef();
  const smoothCylPos = useRef(new THREE.Vector3());
  const targetCylPos = useRef(new THREE.Vector3());
  const cylInit = useRef(false);

  useSmoothPresenceGroup(groupRef, { position, rotation }, 0.5);

  useLayoutEffect(() => {
    if (mouse && position) {
      const py = Array.isArray(position) ? position[1] : position.y;
      const pz = Array.isArray(position) ? position[2] : position.z;
      targetCylPos.current.set(
        mouse.x * 1.5,
        py > 0 ? mouse.y * 1.5 : 1,
        pz > 2 ? -5 : 0
      );
    } else {
      targetCylPos.current.set(0, 0, 0);
    }
    if (!cylInit.current) {
      smoothCylPos.current.copy(targetCylPos.current);
      cylInit.current = true;
    }
  }, [mouse, position]);

  useFrame((_, delta) => {
    if (!cylRef.current) return;
    const t = 1 - Math.exp(-22 * delta);
    smoothCylPos.current.lerp(targetCylPos.current, t);
    cylRef.current.position.copy(smoothCylPos.current);
  });

  return (
    <group ref={groupRef}>
      <Cylinder
        receiveShadow
        material-color={color}
        material={new THREE.MeshStandardMaterial()}
        ref={cylRef}
        args={[0.1, 0, 0.5]}
        rotation={[2, 0, 0]}
      >
        <Edges scale={1} threshold={20} color="grey" />
      </Cylinder>
    </group>
  );
}
